module.exports = __webpack_public_path__ + "static/media/nav-shape.40d7d2ca.svg";